import TransferModal from "./src/index.vue";
import BatchSelectIP from "./src/BatchSelectIP.vue";
import {
	Modal,
	FormModel,
	Cascader,
	Select,
	Spin,
	Empty,
	Icon,
	Checkbox,
	Tooltip,
	Transfer,
	Input,
	Button,
} from "ant-design-vue";
const { Item } = FormModel;
const { TextArea } = Input;
const YwTransferModal = {
	...TransferModal,
	BatchSelectIP,
};

YwTransferModal.install = function (Vue) {
	Vue.component(YwTransferModal.name, YwTransferModal);
	Vue.use(Item);
	Vue.use(Input);
	Vue.use(Cascader);
	Vue.use(Select);
	Vue.use(Spin);
	Vue.use(Empty);
	Vue.use(Icon);
	Vue.use(Checkbox);
	Vue.use(Tooltip);
	Vue.use(Transfer);
	Vue.use(FormModel);
	Vue.use(Button);
	Vue.use(BatchSelectIP);
	Vue.component(BatchSelectIP.name, BatchSelectIP);
	Vue.component(TextArea.name, TextArea);
	Vue.component(Item.name, Item);
	Vue.use(Modal);
};

export default YwTransferModal;
